import { render, staticRenderFns } from "./bbButton.vue?vue&type=template&id=991b90ba"
import script from "./bbButton.vue?vue&type=script&lang=js"
export * from "./bbButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports